import styled from 'styled-components';

export const SelectWrapper = styled.div`
  width: 100%;
  padding: 0.5rem 2rem;
`;
